<template>
  <hit-modal
    popup-size="small"
    :title="
      isAlreadyFavorite
        ? t('hit-app.configuration.remove-favorite')
        : t('hit-app.configuration.save-as-favorite')
    "
    prefix-icon="favorite"
  >
    <div v-if="!isAlreadyFavorite" class="flex flex-col text-panel">
      <span>{{ t('hit-app.configuration.save-as-favorite-description') }}</span>
      <div class="hit-form mt-4 mb-4">
        <hit-input
          :label="t('hit-app.configuration.name')"
          :value="favoriteName"
          @input="(v) => (favoriteName = v)"
        />
      </div>
      <hit-button
        :label="t('hit-components.common.save')"
        :disabled="!favoriteName"
        color="accent"
        @click="saveFavorite"
      />
    </div>
    <div v-else class="flex flex-col text-panel">
      <span>{{
        t('hit-app.configuration.save-as-configuration-delete-description')
      }}</span>
      <hit-button
        :label="t('hit-components.common.delete')"
        color="danger"
        @click="removeFavorite"
      />
    </div>
  </hit-modal>
</template>

<script>
import {HitButton, HitInput, HitModal, HitUUIDUtils} from '@hit/components/src';
import {
  DataService,
  useConfigurationStore,
  useUserProfileStore,
} from '@hit/base';
import {useI18n} from 'vue-i18n';

export default {
  name: 'SaveAsFavoriteModal',
  components: {
    HitModal,
    HitInput,
    HitButton,
  },
  setup() {
    const {t} = useI18n();
    const config = useConfigurationStore();
    const user = useUserProfileStore();
    return {t, user, config};
  },

  data() {
    return {
      favoriteName: null,
      isAlreadyFavorite: false,
    };
  },

  computed: {
    favoriteUrl() {
      return this.$router.currentRoute._value.fullPath;
    },
  },

  beforeMount() {
    this.isAlreadyFavorite = this.config.favorites.find(
      (f) => f.url === this.favoriteUrl,
    );
  },

  methods: {
    saveFavorite() {
      const newFavorite = {
        id: HitUUIDUtils.generate(),
        name: this.favoriteName,
        url: this.favoriteUrl,
      };
      this.config.favorites.push(newFavorite);
      if (this.config.favorites.length === 1) {
        DataService.create('config', {
          id: HitUUIDUtils.generate(),
          label: 'user.favorites',
          user_id: this.user.keycloakId,
          value: this.config.favorites,
          visible: true,
          customisable: true,
          datatype: 'JSON',
          global: false,
        }).then(() => this.$emit('finished'));
      } else {
        DataService.update(
          'config',
          {
            label: 'eq.user.favorites',
            user_id: `eq.${this.user.keycloakId}`,
          },
          {value: this.config.favorites},
        ).then(() => this.$emit('finished'));
      }
    },

    removeFavorite() {
      this.config.updateFavoritesList(
        this.config.favorites.filter((fav) => fav.url !== this.favoriteUrl),
      );
      if (this.config.favorites.length === 0) {
        DataService.delete('config', {
          label: 'eq.user.favorites',
          user_id: `eq.${this.user.keycloakId}`,
        }).then(() => this.$emit('finished'));
      } else {
        DataService.update(
          'config',
          {
            label: 'eq.user.favorites',
            user_id: `eq.${this.user.keycloakId}`,
          },
          {value: this.config.favorites},
        ).then(() => this.$emit('finished'));
      }
    },
  },
};
</script>
